/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { getClientes, crearCliente, actualizarCliente, eliminarCliente } from '../lib/db';

export default function Clientes({ empresaId }) {
  const [clientes, setClientes] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showNuevo, setShowNuevo] = useState(false);
  const [editando, setEditando] = useState(false);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  const [editData, setEditData] = useState(null);
  const [nuevo, setNuevo] = useState({ nombre: '', contacto: '', whatsapp: '', email: '' });

  useEffect(() => {
    const cargar = async () => {
      if (!empresaId) return;
      const { data } = await getClientes(empresaId);
      if (data) setClientes(data);
    };
    cargar();
  }, [empresaId]);

  const guardar = async () => {
    if (!nuevo.nombre) return;
    const { data } = await crearCliente({
      empresa_id: empresaId,
      nombre: nuevo.nombre,
      contacto: nuevo.contacto || null,
      whatsapp: nuevo.whatsapp || null,
      email: nuevo.email || null,
      activo: true,
    });
    if (data) setClientes([...clientes, data]);
    setShowNuevo(false);
    setNuevo({ nombre: '', contacto: '', whatsapp: '', email: '' });
  };

  const guardarEdicion = async () => {
    await actualizarCliente(selected.id, {
      nombre: editData.nombre,
      contacto: editData.contacto || null,
      whatsapp: editData.whatsapp || null,
      email: editData.email || null,
      activo: editData.activo,
    });
    const updated = clientes.map(c => c.id === selected.id ? { ...c, ...editData } : c);
    setClientes(updated);
    setSelected({ ...selected, ...editData });
    setEditando(false);
  };

  const eliminar = async () => {
    await eliminarCliente(selected.id);
    setClientes(clientes.filter(c => c.id !== selected.id));
    setSelected(null);
    setShowConfirmDelete(false);
  };

  const inp = { width: '100%', background: '#181c24', border: '1px solid #222730', borderRadius: '6px', padding: '10px 12px', color: '#e8eaf0', fontSize: '13px' };
  const inpEdit = { ...inp, border: '1px solid #00e5a0' };
  const label = { fontSize: '12px', color: '#9ca3af', display: 'block', marginBottom: '6px' };

  const campos = [
    { label: 'Nombre del cliente', key: 'nombre', placeholder: 'Ej: Grupo Industrial del Norte' },
    { label: 'Contacto', key: 'contacto', placeholder: 'Nombre de la persona de contacto' },
    { label: 'WhatsApp', key: 'whatsapp', placeholder: '+52 81 0000 0000' },
    { label: 'Email', key: 'email', placeholder: 'contacto@empresa.com' },
  ];

  return (
    <div style={{ display: 'flex', height: 'calc(100vh - 60px)' }}>
      {/* Lista lateral */}
      <div style={{ width: '300px', background: '#111318', borderRight: '1px solid #222730', overflowY: 'auto', flexShrink: 0 }}>
        <div style={{ padding: '16px', borderBottom: '1px solid #222730', display: 'flex', alignItems: 'center', justifyContent: 'space-between', position: 'sticky', top: 0, background: '#111318' }}>
          <span style={{ fontSize: '13px', fontWeight: '600', color: '#ffffff' }}>Clientes ({clientes.length})</span>
          <button onClick={() => { setShowNuevo(true); setSelected(null); }}
            style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '5px 10px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>
            + Nuevo
          </button>
        </div>
        <div style={{ padding: '8px' }}>
          {clientes.map(c => (
            <div key={c.id} onClick={() => { setSelected(c); setShowNuevo(false); setEditando(false); }}
              style={{ padding: '14px', borderRadius: '8px', marginBottom: '6px', cursor: 'pointer', border: `1px solid ${selected?.id === c.id ? '#00e5a0' : '#222730'}`, background: selected?.id === c.id ? 'rgba(0,229,160,0.06)' : '#181c24', opacity: c.activo ? 1 : 0.5 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                <span style={{ fontSize: '13px', fontWeight: '700', color: '#e8eaf0' }}>{c.nombre}</span>
                <span style={{ fontSize: '10px', fontWeight: '600', padding: '2px 8px', borderRadius: '10px', background: c.activo ? 'rgba(0,229,160,0.1)' : 'rgba(107,114,128,0.1)', color: c.activo ? '#00e5a0' : '#6b7280' }}>
                  {c.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>
              {c.contacto && <div style={{ fontSize: '11px', color: '#9ca3af' }}>👤 {c.contacto}</div>}
              {c.whatsapp && <div style={{ fontSize: '11px', color: '#25d366', marginTop: '2px' }}>💬 {c.whatsapp}</div>}
            </div>
          ))}
          {clientes.length === 0 && (
            <div style={{ padding: '32px', textAlign: 'center', color: '#6b7280', fontSize: '13px' }}>Sin clientes registrados</div>
          )}
        </div>
      </div>

      {/* Panel derecho */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '28px 32px' }}>
        {!selected && !showNuevo && (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column', gap: '16px' }}>
            <div style={{ fontSize: '48px' }}>👤</div>
            <div style={{ fontSize: '16px', color: '#9ca3af' }}>Selecciona un cliente o agrega uno nuevo</div>
          </div>
        )}

        {showNuevo && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
              <h2 style={{ fontSize: '20px', fontWeight: '700', color: '#ffffff' }}>Nuevo Cliente</h2>
              <button onClick={() => setShowNuevo(false)}
                style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>
                Cancelar
              </button>
            </div>
            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', maxWidth: '600px' }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                {campos.map(f => (
                  <div key={f.key}>
                    <label style={label}>{f.label}</label>
                    <input value={nuevo[f.key]} onChange={e => setNuevo({ ...nuevo, [f.key]: e.target.value })}
                      placeholder={f.placeholder} style={inp} />
                  </div>
                ))}
                <button onClick={guardar}
                  style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '8px', padding: '12px 24px', fontSize: '14px', fontWeight: '700', alignSelf: 'flex-start', cursor: 'pointer' }}>
                  Crear Cliente
                </button>
              </div>
            </div>
          </div>
        )}

        {selected && !showNuevo && (
          <div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
              <div>
                <span style={{ fontSize: '22px', fontWeight: '700', color: '#ffffff' }}>{selected.nombre}</span>
                <span style={{ fontSize: '12px', fontWeight: '600', padding: '3px 10px', borderRadius: '10px', background: selected.activo ? 'rgba(0,229,160,0.1)' : 'rgba(107,114,128,0.1)', color: selected.activo ? '#00e5a0' : '#6b7280', marginLeft: '12px' }}>
                  {selected.activo ? 'Activo' : 'Inactivo'}
                </span>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                {!editando ? (
                  <button onClick={() => { setEditando(true); setEditData({ ...selected }); }}
                    style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>
                    ✏️ Editar
                  </button>
                ) : (
                  <button onClick={guardarEdicion}
                    style={{ background: '#00e5a0', color: '#000', border: 'none', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>
                    💾 Guardar
                  </button>
                )}
                <button onClick={() => setShowConfirmDelete(true)}
                  style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', color: '#ef4444', borderRadius: '6px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer' }}>
                  🗑️ Eliminar
                </button>
              </div>
            </div>

            {showConfirmDelete && (
              <div style={{ background: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '10px', padding: '16px 20px', marginBottom: '20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '13px', color: '#e8eaf0' }}>¿Eliminar cliente <strong style={{ color: '#ef4444' }}>{selected.nombre}</strong>?</span>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <button onClick={eliminar} style={{ background: '#ef4444', color: '#fff', border: 'none', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' }}>Confirmar</button>
                  <button onClick={() => setShowConfirmDelete(false)} style={{ background: 'transparent', border: '1px solid #222730', color: '#9ca3af', borderRadius: '6px', padding: '6px 14px', fontSize: '12px', cursor: 'pointer' }}>Cancelar</button>
                </div>
              </div>
            )}

            <div style={{ background: '#111318', border: '1px solid #222730', borderRadius: '10px', padding: '24px', maxWidth: '600px' }}>
              <div style={{ fontSize: '13px', fontWeight: '600', color: '#6b7280', textTransform: 'uppercase', letterSpacing: '2px', marginBottom: '16px' }}>Datos del Cliente</div>
              {editando ? (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                  {campos.map(f => (
                    <div key={f.key}>
                      <label style={label}>{f.label}</label>
                      <input value={editData[f.key] || ''} onChange={e => setEditData({ ...editData, [f.key]: e.target.value })} style={inpEdit} />
                    </div>
                  ))}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div onClick={() => setEditData({ ...editData, activo: !editData.activo })}
                      style={{ width: '36px', height: '20px', borderRadius: '10px', background: editData.activo ? '#00e5a0' : '#222730', cursor: 'pointer', position: 'relative' }}>
                      <div style={{ width: '14px', height: '14px', borderRadius: '50%', background: '#fff', position: 'absolute', top: '3px', left: editData.activo ? '19px' : '3px', transition: 'left 0.2s' }}></div>
                    </div>
                    <span style={{ fontSize: '13px', color: '#9ca3af' }}>Activo</span>
                  </div>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {[
                    { label: 'Nombre', value: selected.nombre },
                    { label: 'Contacto', value: selected.contacto || '—' },
                    { label: 'WhatsApp', value: selected.whatsapp || '—' },
                    { label: 'Email', value: selected.email || '—' },
                    { label: 'Estado', value: selected.activo ? '● Activo' : '○ Inactivo' },
                  ].map(item => (
                    <div key={item.label}>
                      <div style={{ fontSize: '11px', color: '#6b7280', marginBottom: '4px' }}>{item.label}</div>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: item.label === 'WhatsApp' ? '#25d366' : '#e8eaf0' }}>{item.value}</div>
                    </div>
                  ))}
                  {selected.whatsapp && (
                    <a href={`https://wa.me/${selected.whatsapp.replace(/\D/g,'')}`} target="_blank" rel="noreferrer"
                      style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(37,211,102,0.1)', border: '1px solid rgba(37,211,102,0.2)', color: '#25d366', borderRadius: '8px', padding: '10px 16px', fontSize: '13px', fontWeight: '600', textDecoration: 'none', alignSelf: 'flex-start' }}>
                      💬 Abrir WhatsApp
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}